var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2757_1993",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2757_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9996 41.4C20.8663 41.4 18.2996 41.0333 16.2996 40.3C14.2996 39.5666 13.2996 38.6166 13.2996 37.45C13.2996 36.8833 13.6079 36.3333 14.2246 35.8C14.8413 35.2666 15.6829 34.8166 16.7496 34.45L17.8496 35.3C17.2163 35.5333 16.5663 35.85 15.8996 36.25C15.2329 36.65 14.8329 37.0333 14.6996 37.4C14.8663 38.1 15.8246 38.7083 17.5746 39.225C19.3246 39.7416 21.4663 40 23.9996 40C26.4996 40 28.6329 39.7416 30.3996 39.225C32.1663 38.7083 33.1329 38.1 33.2996 37.4C33.2329 37.0333 32.8246 36.65 32.0746 36.25C31.3246 35.85 30.6163 35.5333 29.9496 35.3L31.0496 34.45C32.2163 34.8166 33.1163 35.2666 33.7496 35.8C34.3829 36.3333 34.6996 36.8833 34.6996 37.45C34.6996 38.6166 33.6996 39.5666 31.6996 40.3C29.6996 41.0333 27.1329 41.4 23.9996 41.4ZM23.9996 35.4C20.1663 32.4666 17.3079 29.6166 15.4246 26.85C13.5413 24.0833 12.5996 21.3666 12.5996 18.7C12.5996 16.7 12.9413 14.95 13.6246 13.45C14.3079 11.95 15.1996 10.6916 16.2996 9.67498C17.3996 8.65831 18.6246 7.89164 19.9746 7.37498C21.3246 6.85831 22.6663 6.59998 23.9996 6.59998C25.3329 6.59998 26.6746 6.85831 28.0246 7.37498C29.3746 7.89164 30.5996 8.65831 31.6996 9.67498C32.7996 10.6916 33.6913 11.95 34.3746 13.45C35.0579 14.95 35.3996 16.7 35.3996 18.7C35.3996 21.3666 34.4579 24.0833 32.5746 26.85C30.6913 29.6166 27.8329 32.4666 23.9996 35.4ZM23.9996 21.45C24.8329 21.45 25.5413 21.1666 26.1246 20.6C26.7079 20.0333 26.9996 19.3166 26.9996 18.45C26.9996 17.6166 26.7079 16.9083 26.1246 16.325C25.5413 15.7416 24.8329 15.45 23.9996 15.45C23.1996 15.45 22.4996 15.7416 21.8996 16.325C21.2996 16.9083 20.9996 17.6166 20.9996 18.45C20.9996 19.3166 21.2996 20.0333 21.8996 20.6C22.4996 21.1666 23.1996 21.45 23.9996 21.45Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistance);
export default __webpack_public_path__ + "static/media/distance.5fae521ea4205ccf151d43eb63cf9f9b.svg";
export { ForwardRef as ReactComponent };